import type { PlusTimePeriod } from '@trinnvis/dabih-api-client';
import type { LocalDate } from '../../../utilities/local-date';
import type { PeriodWithMinutes } from './period-with-minutes';
import { getPeriodsWithMinutes } from './get-periods-with-minutes';

/**
 * Takes a list of periods and a date for year start
 * Returns a list of periods in that year with start and end time in minutes from year start
 */
export function plusTimePeriodsForYear(p: PlusTimePeriod[], yearStartDate: LocalDate): PeriodWithMinutes[] {
  const periodsForYear = p.filter(function (period) {
    return period.start.startsWith(yearStartDate.year() + '') || period.end.startsWith(yearStartDate.year() + '');
  });
  return getPeriodsWithMinutes(periodsForYear, yearStartDate);
}
